import validate from "/var/www/canceller/node_modules/nuxt/dist/pages/runtime/validate.js";
import affiliate_45global from "/var/www/canceller/middleware/affiliate.global.js";
import utm_45global from "/var/www/canceller/middleware/utm.global.js";
import manifest_45route_45rule from "/var/www/canceller/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  affiliate_45global,
  utm_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}